import { Injectable, signal } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

const PREF_KEY   = 'pax_search_history';
const MAX_ITEMS  = 10;

export interface SearchHistoryEntry {
  id: string;
  originLabel: string;
  destinationLabel: string;
  originLat: number;
  originLng: number;
  destLat: number;
  destLng: number;
  searchedAt: string;
}

@Injectable({ providedIn: 'root' })
export class HistoryService {
  readonly history = signal<SearchHistoryEntry[]>([]);

  async load(): Promise<void> {
    const { value } = await Preferences.get({ key: PREF_KEY });
    if (value) this.history.set(JSON.parse(value));
  }

  async push(entry: Omit<SearchHistoryEntry, 'id' | 'searchedAt'>): Promise<void> {
    const id = `${entry.originLat.toFixed(4)},${entry.originLng.toFixed(4)}-${entry.destLat.toFixed(4)},${entry.destLng.toFixed(4)}`;
    const updated = [
      { ...entry, id, searchedAt: new Date().toISOString() },
      ...this.history().filter(h => h.id !== id),
    ].slice(0, MAX_ITEMS);

    this.history.set(updated);
    await Preferences.set({ key: PREF_KEY, value: JSON.stringify(updated) });
  }

  async clear(): Promise<void> {
    this.history.set([]);
    await Preferences.remove({ key: PREF_KEY });
  }
}
